import React from "react";
import PropTypes from "prop-types";
import TextInput from "./TextInput";
import { Alert } from "reactstrap";
import { Formik, Form, Field } from "formik";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import Button from "./CustomButton";

export const EmailForm = props => {
  const {
    icon,
    action,
    failSubmit,
    submitting,
    onSubmit,
    initialValues
  } = props;
  return (
    <Formik
      onSubmit={onSubmit}
      validate={validate}
      initialValues={initialValues}
      render={props => (
        <Form>
          {failSubmit && <Alert color="danger">{failSubmit}</Alert>}
          <Field
            name="email"
            component={TextInput}
            placeholder="Email or Phone Number"
            label="Email or Phone Number"
          />
          <div>
            <Button block fill type="submit" disabled={submitting} color="info">
              {action}{" "}
              {icon && (
                <FontAwesomeIcon style={{ marginLeft: 10 }} icon={icon} />
              )}
            </Button>
          </div>
        </Form>
      )}
    />
  );
};

EmailForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  failSubmit: PropTypes.string,
  initialValues: PropTypes.object.isRequired,
  icon: PropTypes.object,
  action: PropTypes.string
};

EmailForm.defaultProps = {
  action: "Send"
};

export const validate = (values = {}) => {
  const errors = {};
  if (!values.email) {
    errors.email = "Required";
  }
  return errors;
};

export default EmailForm;
